import { Resource } from "@core/shared/types";
import { atom } from "@mongez/react-atom";

export const activeResourceAtom = atom<Resource | null>({
  key: "activeResource",
  default: null,
});

export const displayResourcesAtom = atom<"list" | "grid">({
  key: "displayResources",
  default: "list",
});
